import { atom } from 'recoil';

export const agentState = atom({
  key: 'agentState',
  default: 'spark'
});
